<template>
    <div>
        <div class="errorbox">
            <div class="error" v-for="error in uniqueSquareErrors" :key="error">
                {{ error }}
            </div>
        </div>
        <div id="card-container">
            <loading v-if="loading"/>
        </div>
        <div>
            <button
                :disabled="cardButtonDisabled"
                class='productPurchase payButton'
                @click="handleStoreCardSubmission"
            >
                Save Credit Card
            </button>
        </div>

    </div>
</template>

<script>
import {payments} from "@square/web-sdk"
import Payments from "src/api/Payments";
export default {
    name : "SquareCard",
    props : {
        id : String,
        activeProvider : {
            type : Object,
            required : true,
        },
        ccMethod : {
            type : Object,
            required : true,
        }
    },
    data : function () {
        return {
            squareErrors : [],
            saving : false,
            payments : null,
            card : null,
            cardButtonDisabled : false,
            loading : true,
        };
    },
    computed : {
        providerId() {
            return this.activeProvider.id;
        },
        methodId() {
            return this.ccMethod.id;
        },
        uniqueSquareErrors() {
            return [...new Set(this.squareErrors)];
        },
        applicationSetting() {
            return this.activeProvider.settings
                .find(s => s.key === "square_application_id");
        },
        applicationId() {
            return this.applicationSetting ? this.applicationSetting.value : null;
        }
    },
    mounted() {
        this.initializeSquare();
    },
    methods : {
        async initializeSquare() {
            await payments(this.applicationId).then(value => {
                this.payments = value;
            }).catch(() => {
                this.squareErrors.push('Initializing Square failed');
            });
            this.card = await this.initializeCard();
            this.loading = false;
        },
        async initializeCard() {
            const card = await this.payments.card();
            await card.attach('#card-container');
            return card;
        },
        async handleStoreCardSubmission() {
            this.cardButtonDisabled = true;

            try {
                const token = await this.tokenizeCard();
                const constRequestBody = {
                    methodId : this.methodId,
                    providerId : this.providerId,
                    nonce : token,
                };
                Payments.createSquarePaymentCard(constRequestBody).then(tokenResponse => {
                    let squareMetadata = tokenResponse.data;
                    this.$emit('create-payment-method', {
                        method : {
                            paymentProviderId : this.providerId,
                            paymentProviderMethodId : this.methodId,
                            last4 : tokenResponse.data.card.last4,
                            metaData : JSON.stringify(squareMetadata),
                        },
                        settings : [
                            {
                                key : 'nonce',
                                value : token,
                                accountPaymentProviderId : this.activeProvider.accountPaymentProvider.id
                            },
                            {
                                key : 'square_customer_id',
                                value : squareMetadata.customer_id,
                                accountPaymentProviderId : this.activeProvider.accountPaymentProvider.id
                            },
                            {
                                key : 'square_card_id',
                                value : squareMetadata.card.id,
                                accountPaymentProviderId : this.activeProvider.accountPaymentProvider.id
                            }
                        ]
                    });
                });
            } catch (e) {
                this.cardButtonDisabled = false;
                this.squareErrors.push('Store Card Failure');
            }
        },
        async tokenizeCard() {
            const tokenResult = await this.card.tokenize();
            if (tokenResult.status === 'OK') {
                return tokenResult.token;
            } else {
                this.cardButtonDisabled = false;
                const errorMessage = JSON.stringify(tokenResult.errors);
                this.squareErrors.push(errorMessage);
            }
        },
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.errorbox {
    line-height: 14px;
    text-align: left;
}
</style>
